import { useContext } from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';
import InputField from '../../../../components/InputField';
import LanguageField from '../../../../components/LanguageField';
import LocaleField from '../../../../components/LocaleField';
import { CountryCodeField, PhoneInputField } from '../../../../components/PhoneInputField';
import TimezoneField from '../../../../components/TimezoneField';
import LegalNameVerification from '../../../../components/LegalNameVerification';
import GeneralEditContext from './GeneralEditContext';
import {
    desktopCSS,
    legalNameVerifiedCSS,
    phoneNumberFieldCSS,
    saveCancelActionsCSS,
} from './generalEditCSS';

const GeneralEditDesktop = () => {
    const {
        countries,
        countryCode,
        countryCodeError,
        enableUserProfileStandardization,
        fieldLabels: {
            cancelLabel,
            countryCodeLabel,
            firstNameLabel,
            languageLabel,
            lastNameLabel,
            localeLabel,
            middleNameLabel,
            mobilePhoneLabel,
            prefixLabel,
            saveLabel,
            suffixLabel,
            timezoneLabel,
        },
        firstName,
        language,
        lastName,
        legalNameVerified,
        locale,
        middleName,
        onCancel,
        onCountryCodeChange,
        onFirstNameChange,
        onLanguageChange,
        onLastNameChange,
        onLegalNameVerifiedChange,
        onLocaleChange,
        onMiddleNameChange,
        onPhoneChange,
        onPrefixChange,
        onSave,
        onSuffixChange,
        onTimezoneChange,
        options,
        phone,
        phoneDisabled,
        phoneError,
        prefix,
        saveButtonDisabled,
        suffix,
        timezone,
    } = useContext(GeneralEditContext);

    const { languages, locales, timezones } = options;

    return (
        <div css={desktopCSS}>
            {enableUserProfileStandardization && (
                <InputField label={prefixLabel} onChange={onPrefixChange} value={prefix} />
            )}
            <InputField
                label={`${firstNameLabel}*`}
                onChange={onFirstNameChange}
                value={firstName}
            />
            {enableUserProfileStandardization && (
                <InputField
                    label={middleNameLabel}
                    onChange={onMiddleNameChange}
                    value={middleName}
                />
            )}
            <InputField label={`${lastNameLabel}*`} onChange={onLastNameChange} value={lastName} />
            {enableUserProfileStandardization && (
                <InputField label={suffixLabel} onChange={onSuffixChange} value={suffix} />
            )}
            <EmotionThemeProvider theme={{ selectFieldInputWidth: '16.667rem' }}>
                <div css={phoneNumberFieldCSS}>
                    <CountryCodeField
                        countries={countries}
                        label={countryCodeLabel}
                        value={countryCode}
                        onChange={onCountryCodeChange}
                        errorMessage={countryCodeError}
                    />
                    <PhoneInputField
                        label={mobilePhoneLabel}
                        value={phone}
                        onChange={onPhoneChange}
                        errorMessage={phoneError}
                        disabled={phoneDisabled}
                    />
                </div>
            </EmotionThemeProvider>
            <LanguageField
                label={languageLabel}
                languages={languages}
                onChange={onLanguageChange}
                value={language}
            />
            <LocaleField
                label={localeLabel}
                locales={locales}
                onChange={onLocaleChange}
                value={locale}
            />
            <TimezoneField
                label={timezoneLabel}
                onChange={onTimezoneChange}
                timezones={timezones}
                value={timezone}
            />
            <div css={legalNameVerifiedCSS}>
                <LegalNameVerification
                    legalNameVerified={legalNameVerified}
                    onChange={onLegalNameVerifiedChange}
                />
            </div>
            <div css={saveCancelActionsCSS}>
                <CancelButton label={cancelLabel} onClick={onCancel} />
                <Button disabled={saveButtonDisabled} onClick={onSave}>
                    {saveLabel}
                </Button>
            </div>
        </div>
    );
};

export default GeneralEditDesktop;
